module.exports = __webpack_public_path__ + "img/29.4ea771c4.jpg";